angular.module('moebiusProadapt').controller('ctrlParticipantEicomplication',
    ['$rootScope', '$scope', '$http', 'moment', '$timeout', '$location', '$controller', 'mbsEtiService', 'mbsParticipantService', '$uibModal','eti','questionVisite','participant','questionMere','linkedObject',
        function ($rootScope, $scope, $http, moment, $timeout, $location, $controller, mbsEtiService, mbsParticipantService, $uibModal, eti, questionVisite, participant, questionMere,linkedObject) {

            $scope.eicomplication   = linkedObject;

            $scope.constants = $rootScope.constants;

            $scope.grades = [];
            _.each($scope.constants.grade_toxicite_types.VALUES_TO_DISPLAY,function(value,key){
                $scope.grades.push({id:parseInt(key),label:value});
            });
            $scope.actions = [];
            _.each($scope.constants.action_toxicite_types.VALUES_TO_DISPLAY,function(value,key){
                $scope.actions.push({id:parseInt(key),label:value});
            });
            $scope.evolutions= [];
            _.each($scope.constants.evolution_toxicite_types.VALUES_TO_DISPLAY,function(value,key){
                $scope.evolutions.push({id:parseInt(key),label:value});
            });
            $scope.gradesChir = [];
            _.each($scope.constants.grade_complication_chirurgicale_types.VALUES_TO_DISPLAY,function(value,key){
                $scope.gradesChir.push(
                    {
                        id:parseInt(key),
                        label:value,
                        //description: $scope.constants.grade_complication_chirurgicale_types.VALUES_TO_DESCRIPTION[key]
                    });
            });

            $scope.selectedGradeLabels = [];
            $scope.selectedGradeLabel = '';
            $scope.selectedGradeDescription = '';

            console.log('eicomplication received', $scope.eicomplication );

            $scope.areDatesValid = function()  {
                if(
                    $scope.eicomplication.date_debut === null
                    || $scope.eicomplication.date_fin === null
                    || ($scope.eicomplication.date_debut <= $scope.eicomplication.date_fin)
                ) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.title        = questionMere.name;
            $scope.titleConfirm = 'OK';

            if ($scope.eicomplication.editOrSave === 'SAVE') {
                $scope.title        = $scope.title + '-' + 'Ajout';
                $scope.titleConfirm = 'Ajouter';

            } else {
                $scope.title        = $scope.title + '-' + 'Edition';
                $scope.titleConfirm = 'Modifier';
            }

            // -- init
            if ($scope.eicomplication.date_debut) {
                $scope.eicomplication.date_debut = moment($scope.eicomplication.date_debut).hour(12).toDate();
            }
            if ($scope.eicomplication.date_fin) {
                $scope.eicomplication.date_fin = moment($scope.eicomplication.date_fin).hour(12).toDate();
            }
            $scope.eicomplication.chir_fiche4_dindo_action = parseInt($scope.eicomplication.chir_fiche4_dindo_action) ;

            $scope.getComplication = function(val) {
                return $http.post('participant-eicomplication/search-code-meddra', {search_code_meddra: val})
                    .then(function(response){
                        $scope.selectedGradeLabels =  response.data;
                        $scope.displaySelectedGradeLabel();
                        return $scope.selectedGradeLabels;
                        // return response.data.map(function(item){
                        //     return item.libelle_theriaque;
                        // });
                    });
            };
            $scope.getReverseComplication = function(val) {
                return $http.post('participant-eicomplication/search-terme', {search_terme: val})
                            .then(function(response){
                                $scope.selectedGradeLabels =  response.data;
                                $scope.displaySelectedGradeLabel();
                                return $scope.selectedGradeLabels;
                            });
            };

            $scope.displaySelectedGradeLabel = function(){
                var index = _.findIndex($scope.selectedGradeLabels,{code:$scope.eicomplication.med_fiche3_ctc_meddra_code});
                if(index !== -1){
                    $scope.selectedGradeLabel = $scope.selectedGradeLabels[index]['grade'+$scope.eicomplication.med_fiche3_ctc_grade];
                    //on récupère la description anglophone
                    $scope.eicomplication.med_fiche3_ctc_anglophone_description = $scope.selectedGradeLabel;
                }
            };

            $scope.displaySelectedGradeDescription = function(){
                $scope.selectedGradeDescription = $scope.constants.grade_complication_chirurgicale_types.VALUES_TO_DESCRIPTION[$scope.eicomplication.chir_fiche4_dindo_grade];
            };

            $scope.selectComplicationMed = function($item, $model, $label, $event) {
                console.log('-------- SELECTED TOXICITE');
                if ($item) {
                    $scope.eicomplication.med_fiche3_ctc_meddra_code = $item.code;
                    $scope.eicomplication.med_fiche3_ctc_meddra_soc = $item.soc;
                    $scope.eicomplication.med_fiche3_ctc_meddra_terme = $item.terme;
                    $scope.eicomplication.grade_label = $item.terme;
                } /*else {
                    // $scope.eicomplication.eicomplication_id                     = null;
                    // $scope.eicomplication.atc_specialite_medicamenteuse     = null;
                    // $scope.eicomplication.ucd13_specialite_medicamenteuse   = null;
                }*/
                console.log('$item',$item);
                console.log('$model', $model);
                console.log('$label', $label);
                console.log('$event', $event);
            };

            $scope.canValidateComplicMeddra = function(){
                if(
                    !$scope.eicomplication.med_fiche3_ctc_meddra_code
                    || $scope.eicomplication.med_fiche3_ctc_meddra_code.length <= 3
                    || !$scope.eicomplication.med_fiche3_ctc_meddra_terme
                    || $scope.eicomplication.med_fiche3_ctc_meddra_terme.length <= 3
                    || !$scope.eicomplication.med_fiche3_ctc_grade
                    || !$scope.eicomplication.med_fiche3_ctc_action
                    || !$scope.eicomplication.med_fiche3_ctc_evolution
                    || !$scope.areDatesValid()
                ) {return false;}

                return true;

            };
            $scope.canValidateComplicClavienDindo = function(){

                if(
                    !($scope.eicomplication.chir_fiche4_dindo_grade >= 0)
                    || !$scope.eicomplication.chir_fiche4_dindo_action
                    || !$scope.eicomplication.chir_fiche4_dindo_evolution
                    || !$scope.areDatesValid()
                ) {return false;}

                return true;

            };

        /**
         * *************************************************************************************************
         * ********************* Initialization
         * *************************************************************************************************
         */
        $scope.getComplication('100');
        $scope.displaySelectedGradeDescription();

        //
        // /**
        //  * setup the controller
        //  */
        // var initialize = function () {
        // };
        //
        // initialize();
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/participantEicomplication.js